// extracted by mini-css-extract-plugin
export default {"dotloopModal":"SopgfQsfgKQ7l_mF3BJt"};